const prepareSpecs = (arrOfSpecs: any) => {
  return arrOfSpecs && arrOfSpecs.length
    ? arrOfSpecs.map((el: any) => ({ label: el.name, value: el.id }))
    : undefined
}

export default prepareSpecs
